import { Component, OnInit } from '@angular/core';
import { SuppliersService } from '../../core/services/suppliers.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UiService } from '../../core/services/ui.service';

@Component({
  selector: 'suppliers-edit',
  templateUrl: 'suppliers-create-edit.template.html',
})
export class SuppliersEditComponent implements OnInit {
  public supplier;
  constructor(
    private suppliersSrv: SuppliersService,
    private route: ActivatedRoute,
    private router: Router,
    private ui: UiService
  ) {}
  ngOnInit() {
    this.ui.toolbar.title = 'Editar proveedor';
    var supplierId = this.route.snapshot.params['id'];
    this.suppliersSrv.find(supplierId).then((supplier) => (this.supplier = supplier));
  }
  handleSubmit(evt) {
    evt.preventDefault();
    this.saveSupplier();
  }
  saveSupplier() {
    this.suppliersSrv.save(this.supplier).then((supplier) => {
      this.ui.snackbar.show({
        message: 'Proveedor modificado!',
      });
      this.router.navigate(['/tasks/suppliers/' + supplier.id]);
    });
  }
}
